import { logEventOnServer } from "@root/store/thunks";

export const LENDING_OPENED = "LANDING_PAGE_VISITORS";

export const reportDashboardLending = (parameters: any, dispatch: any) => {
  if (
    process.env.REACT_APP_ENV === "production" ||
    process.env.REACT_APP_ENV === "development"
  ) {
    // dispatch(logEventOnServer(parameters));
  }
};
